'use strict';

var cov_16vjh2zw6r = function () {
  var path = 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\tintuc\\tintuc.js',
      hash = '0234fddfaef76dd60cbf09b35d3e2be015303d0f',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\tintuc\\tintuc.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 42
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 45
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 7,
          column: 7
        }
      },
      '3': {
        start: {
          line: 6,
          column: 6
        },
        end: {
          line: 6,
          column: 39
        }
      },
      '4': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 10,
          column: 7
        }
      },
      '5': {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 40
        }
      },
      '6': {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 13,
          column: 6
        }
      },
      '7': {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 29
        }
      },
      '8': {
        start: {
          line: 17,
          column: 0
        },
        end: {
          line: 22,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 64
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 76
          },
          end: {
            line: 5,
            column: 77
          }
        },
        loc: {
          start: {
            line: 5,
            column: 87
          },
          end: {
            line: 7,
            column: 5
          }
        },
        line: 5
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 8,
            column: 80
          },
          end: {
            line: 8,
            column: 81
          }
        },
        loc: {
          start: {
            line: 8,
            column: 91
          },
          end: {
            line: 10,
            column: 5
          }
        },
        line: 8
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 11,
            column: 19
          },
          end: {
            line: 11,
            column: 20
          }
        },
        loc: {
          start: {
            line: 11,
            column: 31
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 11
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TintucController = function TintucController($scope, $rootScope, $http, $stateParams, $window) {
  _classCallCheck(this, TintucController);

  ++cov_16vjh2zw6r.f[0];
  ++cov_16vjh2zw6r.s[0];

  this.text = 'My brand new component!';
  ++cov_16vjh2zw6r.s[1];
  $scope.cateid = $stateParams.categorieid;
  ++cov_16vjh2zw6r.s[2];
  $http.get($rootScope.apiOpen + 'categories/find/' + $scope.cateid).then(function (results) {
    ++cov_16vjh2zw6r.f[1];
    ++cov_16vjh2zw6r.s[3];

    $scope.categoties = results.data;
  });
  ++cov_16vjh2zw6r.s[4];
  $http.get($rootScope.apiOpen + 'article/getByCateID/' + $scope.cateid).then(function (results) {
    ++cov_16vjh2zw6r.f[2];
    ++cov_16vjh2zw6r.s[5];

    $scope.articleData = results.data;
  });
  ++cov_16vjh2zw6r.s[6];
  $scope.totop = function () {
    ++cov_16vjh2zw6r.f[3];
    ++cov_16vjh2zw6r.s[7];

    $window.scrollTo(0, 0);
  };
};

++cov_16vjh2zw6r.s[8];


angular.module('app').component('tintuc', {
  templateUrl: 'app/tintuc/tintuc.html',
  controller: TintucController
});